import { BorderColors, BorderRadius } from "@abel-technologies-as/components";

const contractInfoWrapper = {
	padding: "24px",
	minHeight: "135px",
	border: `1px solid ${BorderColors.Secondary}`,
	borderRadius: `${BorderRadius.LG}px`,
};

export { contractInfoWrapper };
